import { getCurrentItem } from '../../store/selectors/getCurrentItem';
import { useIsAnyItemSelectedSelector } from '../../store/selectors/useIsAnyItemSelectedSelector';
import { useStudentSelector } from '../../store/selectors/useStudentSelector';
import { isNonSequencedFlowItem } from '@ael/core-api';

export const useDisplayProgressDialog = () => {
  const anyItemSelected = useIsAnyItemSelectedSelector();
  const currentItem = useStudentSelector((state) => getCurrentItem(state));

  if (!anyItemSelected || !currentItem) {
    return true;
  }

  const isCurrentItemNonSequencedFlow = isNonSequencedFlowItem(currentItem);

  return isCurrentItemNonSequencedFlow;
};
